import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardFooter,
  Table,
  Row,
  Input,
  Col,
  Form,
  FormGroup,
  Label
} from "reactstrap";
import Select from "react-select";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { PanelHeader, Button, Stats, Statistics, Technician } from "components";

import { theadcontracts, theadcontracttemplates, tbody, theadhomevisits } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";
import Datetime from "react-datetime";
import moment from "moment";
import "moment/locale/es";

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

const ESTADO_FACTURA = "estado-factura";
const ENVIO = "envio";
const NOTA = "nota";
const INTERNET = "internet";
const AGREGAR_MOVIL = "agregar-movil";
const GASTO_EXTRA = "gasto-extra";
const CONTRATO_ESPERANDO = 229;
const CONTRATO_FICHA_LISTA = 231;
const CONTRATO_FIRMADO = 230;
const CONTRATO_RELLENANDO = 238;

var localityStyle = {
  padding: "5px 10px",
  background: "rgba(0,0,0,0.1)",
  borderRadius: "2px",
  margin: "0px 10px 0px 5px"
};

class HomeVisitsList extends React.Component {
  constructor(props) {
    let initShowHomeVisits = [];
    initShowHomeVisits["hoy"] = true;
    super(props);
    this.state = {
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de facturas",
      toDashboard: false,
      searchQuery: "",
      showPopUp: false,
      popUpConfirmation: null,
      popUpToShow: null,
      currentBillStatus: null,
      currentBillID: "",
      currentBillNumber: "",
      goToCreateCustomer: false,
      loadingContractToCreateCustomer: false,
      date_day_min: this.props.mainState.date_day_min || moment(),
      date_day_max: this.props.mainState.date_day_max || moment().add(7, "days"),
      showHomeVisits: initShowHomeVisits,
      showFinishedHomeVisits: [],
      showFilter: false
    };
    ////console.log(props);
    this.viewOrderArticles = this.viewOrderArticles.bind(this);
    this.loadOrdersChart = this.loadOrdersChart.bind(this);
    this.getViewArticlesButton = this.getViewArticlesButton.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.searchHomeVisits = this.searchHomeVisits.bind(this);
    this.createPopUp = this.createPopUp.bind(this);
    this.createBillStatusPopUp = this.createBillStatusPopUp.bind(this);
    this.editBillStatusConfirmation = this.editBillStatusConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.paymentStatus = this.paymentStatus.bind(this);
    this.openBillStatusPopUpFromBill = this.openBillStatusPopUpFromBill.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.createCustomer = this.createCustomer.bind(this);
    this.deleteContract = this.deleteContract.bind(this);
    this.buildContractsCount = this.buildContractsCount.bind(this);
    this.searchFromCounter = this.searchFromCounter.bind(this);
    this.cleanStatusesFromSearchQuery = this.cleanStatusesFromSearchQuery.bind(this);
    this.buildCurrentHomeVisit = this.buildCurrentHomeVisit.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    
    this.props.userData.getHomeVisitTypesList();
    this.props.userData.getHomeVisitFinishReasonList();
  }
  componentDidMount() {
    // NEW
    this.props.userData.searchHomeVisits("", this.state.date_day_min, this.state.date_day_max);
    this.props.userData.getCurrentHomeVisit();
    this.props.userData.getCalendarsList();
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log("TEST HOME VISITS - STATE");
    // console.log(this.props.mainState);
    if (this.state.loadingContractToCreateCustomer && this.props.mainState.contract) {
      this.props.createCustomerFromContract(this.props.mainState.contract);
      this.setState({
        goToCreateCustomer: true
      });
    }
    let date_change_min = this.state.date_day_min !== prevState.date_day_min;
    let date_change_max = this.state.date_day_max !== prevState.date_day_max;
    if (date_change_min || date_change_max) {
      this.props.userData.searchHomeVisits(this.state.searchQuery, this.state.date_day_min, this.state.date_day_max);
    }
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case ESTADO_FACTURA:
        return this.createBillStatusPopUp();
      case ENVIO:
        return this.createDeliveryPopUp();
      case NOTA:
        return this.createNotePopUp();
      case INTERNET:
        return this.configureInternetPopUp();
      case AGREGAR_MOVIL:
        return this.addMobilePopUp();
      case GASTO_EXTRA:
        return this.createExtraExpensePopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  createCustomer(contract) {
    this.setState({
      loadingContractToCreateCustomer: true
    });
    this.props.getContract(contract.id);
  }
  createBillStatusPopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Editar estado"
        onConfirm={() => this.showPopUpConfirmation(ESTADO_FACTURA)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Guardar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Estado</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Estado"
                  name="estado"
                  value={this.state.currentBillStatus}
                  options={this.props.mainState.billStatuses.forOptions}
                  onChange={value =>
                    this.setState({ currentBillStatus: value })
                  }
                />
                <br></br>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case NOTA:
        this.newNoteConfirmation();
        break;
      case ESTADO_FACTURA:
        this.editBillStatusConfirmation();
        break;
      case ENVIO:
        this.newDeliverySIMConfirmation();
        break;
      case INTERNET:
        this.configureInternetConfirmation();
        break;
      case AGREGAR_MOVIL:
        this.addMobile();
        break;
      case GASTO_EXTRA:
        this.newExtraExpenseConfirmation();
        break;
      default:;
    }
  }
  editBillStatusConfirmation() {
    this.props.editBill(
      this.state.currentBillID,
      this.state.currentBillStatus.value,
      this.state.currentBillNumber
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Estado editado!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          El estado ha sido editado.
        </SweetAlert>
      )
    });
  }
  openBillStatusPopUpFromBill(order) {
    console.log("################## OPEN BILL STATUS ################");
    console.log(order);
    let billID = order.order_id;
    let billStatus = order.estado_pedido;
    let billNumber = order.numero_pedido;
    let _currentBillStatus = null;
    this.props.mainState.billStatuses.forOptions.map(currentStatus => {
      if (currentStatus.label === billStatus)
        _currentBillStatus = currentStatus;
    });
    this.setState({
      currentBillID: billID,
      currentBillStatus: _currentBillStatus,
      currentBillNumber: billNumber
    });
    this.showPopUp(ESTADO_FACTURA);
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      popUpConfirmation: null
    });
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  loadOrdersChart() {
    let ordersChartDates = [];
    let ordersChartTotals = [];
    let partialOrders = [];
    /* if(this.props.mainState.orders.length > this.state.ordersToDisplayInChart) {
      partialOrders = this.props.mainState.orders.slice(0,this.state.ordersToDisplayInChart).reverse();
    }else{ */
      partialOrders = this.props.mainState.orders.slice(0).reverse();
    /* } */
    partialOrders.map((currentOrder, key) =>{
      ordersChartDates.push(
        new Intl.DateTimeFormat("es-ES", {
          year: "numeric",
          month: "short"
        })
          .format(Date.parse(currentOrder.fecha))
          .replace(".", "")
      );
      ordersChartTotals.push(
        parseFloat(
          currentOrder.total
            .replace(",", ".")
            .substring(0, currentOrder.total.length - 2)
        )
      );
    });

    let ordersChart = {
      data: canvas => {
        const ctx = canvas.getContext("2d");
        var chartColor = "#FFFFFF";
        var gradientStroke = ctx.createLinearGradient(500, 0, 100, 0);
        gradientStroke.addColorStop(0, "#80b6f4");
        gradientStroke.addColorStop(1, chartColor);
        var gradientFill = ctx.createLinearGradient(0, 200, 0, 50);
        gradientFill.addColorStop(0, "rgba(128, 182, 244, 0)");
        gradientFill.addColorStop(1, "rgba(255, 255, 255, 0.14)");
    
        return {
          labels: ordersChartDates,
          datasets: [
            {
              label: "Total",
              borderColor: chartColor,
              pointBorderColor: chartColor,
              pointBackgroundColor: "#2c2c2c",
              pointHoverBackgroundColor: "#2c2c2c",
              pointHoverBorderColor: chartColor,
              pointBorderWidth: 1,
              pointHoverRadius: 7,
              pointHoverBorderWidth: 2,
              pointRadius: 5,
              fill: true,
              backgroundColor: gradientFill,
              borderWidth: 2,
              data: ordersChartTotals
            }
          ]
        };
      },
      options: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 0,
            bottom: 0
          }
        },
        maintainAspectRatio: false,
        tooltips: {
          backgroundColor: "#fff",
          titleFontColor: "#333",
          bodyFontColor: "#666",
          bodySpacing: 4,
          xPadding: 12,
          mode: "nearest",
          intersect: 0,
          position: "nearest"
        },
        legend: {
          position: "bottom",
          fillStyle: "#FFF",
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold",
                beginAtZero: true,
                maxTicksLimit: 5,
                padding: 10,

                // Return an empty string to draw the tick line but hide the tick label
                // Return `null` or `undefined` to hide the tick line entirely
                userCallback: function(value, index, values) {
                    // Convert the number to a string and splite the string every 3 charaters from the end
                    value = value.toString();
                    value = value.split(/(?=(?:...)*$)/);
        
                    // Convert the array to a string and format the output
                    value = value.join('.');
                    return value + ' €';
                }
              },
              gridLines: {
                drawTicks: true,
                drawBorder: false,
                display: true,
                color: "rgba(255,255,255,0.1)",
                zeroLineColor: "transparent"
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
                color: "rgba(255,255,255,0.1)"
              },
              ticks: {
                padding: 10,
                fontColor: "rgba(255,255,255,0.4)",
                fontStyle: "bold"
              }
            }
          ]
        }
      }
    };

    let firstOrderDate = 
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[0].fecha))
        .replace(".", "");
    let lastOrderDate = 
      new Intl.DateTimeFormat("es-ES", {
        year: "numeric",
        month: "short"
      })
        .format(Date.parse(partialOrders[partialOrders.length-1].fecha))
        .replace(".", "");

    this.setState({
      ordersChartReady: true,
      ordersChart: ordersChart,
      ordersHistoryTitle: "Histórico de facturas (" + firstOrderDate + " - " + lastOrderDate + ")"
    });
  }
  downloadBill(url, orderNumber, event) {
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  goToDashboard() {
    this.setState({
      toDashboard: true
    });
  }
  paymentStatus(order) {
    let statusReady = null;
    let payment = order.estado_pedido;
    let statusButtonColor = "default";
    let statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    if (payment.includes("Pendiente")) {
      statusButtonColor = "warning";
      statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    } else if(payment.includes("Pagada")){
      statusButtonColor = "primary";
      statusButtonIcon = "now-ui-icons ui-1_check";
    } else if(payment.includes("Procesando")){
      statusButtonColor = "info";
      statusButtonIcon = "now-ui-icons arrows-1_refresh-69 spin";
    } else /*if(payment.includes("Recibo"))*/{
      statusButtonColor = "danger";
      statusButtonIcon = "now-ui-icons ui-1_simple-remove";
    }

    statusReady =                   
    <Button
      color={statusButtonColor}
      size="sm"
      onClick={() => {this.openBillStatusPopUpFromBill(order)}}
    >
      <i className={statusButtonIcon} /> {payment}
    </Button>;

    return statusReady;
  }
  downloadButton(order) {
    let button = 
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>;

    if(this.state[order]){
      button = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }

    return button;
  }
  viewOrderArticles(order) {
    let orderDetailContent =
      <div>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              <th className="text-center">
                Concepto
              </th>
              <th className="text-center">
                Precio
              </th>     
            </tr>
          </thead>
          <tbody>
            {this.props.mainState.ordersArticles[order].map((article, key) => {
              return (
                <tr key={key}>
                  <td className="text-center">{article.titulo}</td>
                  <td className="text-center">{article.total}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>;
    this.setState({
      orderDetail: orderDetailContent,
      showDetail: true
    })
  }
  handleChange(field, event) {
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  getViewArticlesButton(order) {
    let button = 
      <Button
        color="default"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" /> Ver
        </div>
      </Button>;

    if(true /*order in this.props.mainState.ordersArticles*/){
      button = 
      <Link to={"/facturas/".concat(order)}>
        <Button
          color="info"
          size="sm"
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons education_glasses" /> Ver
          </div>
        </Button>
      </Link>;
    }

    return button;
  }
  searchHomeVisits() {
    if (!this.props.mainState.isSearchingHomeVisits)
      this.props.userData.searchHomeVisits(this.state.searchQuery, this.state.date_day_min, this.state.date_day_max);
  }
  deleteContract(contract) {
    let contractToDelete = {
      contract_id: contract.id
    };
    this.props.deleteContract(contract);
  }
  buildTemplateActions(template) {
    let templateActions = [];
    templateActions.push(
      <Link
        key={"openTemplateButton" + template.id}
        to={"/contratos/editar/".concat(template.id)}>
        <Button
          round
          color="info"
          size="sm"
          // icon
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons arrows-1_share-66" /> Abrir
          </div>
        </Button>
      </Link>
    );
    // console.log("TEST OWNER");
    // console.log("template.owner");
    // console.log(template.owner);
    // console.log("this.props.mainState.user.id");
    // console.log(this.props.mainState.user.uid);
    if (parseInt(template.owner) === parseInt(this.props.mainState.user.uid)) {
      templateActions.push(<span key="separador-1">{" "}</span>);
      templateActions.push(
        <Button
          key={"deleteTemplateButton" + template.id}
          round
          color="danger"
          size="sm"
          // icon
          onClick={e =>
            this.deleteContract(template)
          }
        >
          <div>
            <i className="now-ui-icons ui-1_simple-remove" /> Borrar
          </div>
        </Button>
      );

    }
    return templateActions;
  }
  buildContractActions(contract) {
    let contractActions = [];
    contractActions.push(
      <Link
        key={"viewContractButton" + contract.id} 
        to={"/contratos/".concat(contract.id)}>
        <Button
          round
          color="info"
          size="sm"
          // icon
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons education_glasses" /> Ver
          </div>
        </Button>
      </Link>
    );
    // Si todavía no está firmado el contrato
    // console.log("---------------- contrato estado firma -----------------");
    // console.log(contract);
    if (contract.estado_id && parseInt(contract.estado_id.tid) !== 230 && parseInt(contract.estado_id.tid) !== 231) {
      contractActions.push(<span key="separador-3">{" "}</span>);
      contractActions.push(
        <Link
          key={"editContractButton" + contract.id} 
          to={"/contratos/editar/".concat(contract.id)}>
          <Button
            round
            color="primary"
            size="sm"
            // icon
            /* onClick={e =>
              this.viewOrderArticles(order.numero_pedido, e)
            } */
          >
            <div>
              <i className="now-ui-icons loader_gear" /> Editar
            </div>
          </Button>
        </Link>
      );
    }
    if (contract.estado_id) {
      if (contract.client_id && parseInt(contract.client_id) > 0 && parseInt(contract.estado_id.tid) === 231) {
        contractActions.push(<span key="separador-4">{" "}</span>);
        contractActions.push(
          <Link
            key={"viewClientButton" + contract.id + contract.client_id} 
            to={"/clientes/fichas/".concat(contract.client_id)}>
            <Button
              round
              color="primary"
              size="sm"
              // icon
              /* onClick={e =>
                this.viewOrderArticles(order.numero_pedido, e)
              } */
            >
              <div>
                <i className="now-ui-icons arrows-1_share-66" /> Ver ficha
              </div>
            </Button>
          </Link>
        );
      } else if(parseInt(contract.estado_id.tid) === 230) {
        contractActions.push(<span key="separador-2">{" "}</span>);
        contractActions.push(
          // <Link to={"/clientes/nuevo"}>
          <Button
            key={"createClientButton" + contract.id}
            round
            color="primary"
            size="sm"
            // icon
            onClick={e =>
              this.createCustomer(contract)
            } 
          >
            <div>
              <i className="now-ui-icons ui-1_simple-add" /> Crear ficha
            </div>
          </Button>
          // </Link>
        );
      }
    }
    return contractActions;
  }
  buildContractState(contract) {
    let contractState = null;
    let stateText = "Error";
    let stateColor = "default";
    let stateIcon = "ui-1_simple-remove";
    if (contract.estado_id && parseInt(contract.estado_id.tid) > 0) {
      let state_id = parseInt(contract.estado_id.tid);
      switch (state_id) {
        case CONTRATO_ESPERANDO:
          stateText = contract.estado;
          stateColor = "danger";
          stateIcon = "ui-2_time-alarm";
          break;
        case CONTRATO_FICHA_LISTA:
          stateText = contract.estado;
          stateColor = "primary";
          stateIcon = "ui-2_favourite-28";
          break;
        case CONTRATO_FIRMADO:
          stateText = contract.estado;
          stateColor = "info";
          stateIcon = "ui-1_check";
          break;
        case CONTRATO_RELLENANDO:
          stateText = contract.estado;
          stateColor = "warning";
          stateIcon = "arrows-1_refresh-69 spin reposition-spin";
          break;
        default:
          stateText = "Error";
          stateColor = "default";
          stateIcon = "ui-1_simple-remove";
          break;
      }
    } else {
      stateText = "Error";
      stateColor = "default";
      stateIcon = "ui-1_simple-remove";
    }

    contractState = (
      <Button
        round
        color={stateColor}
        size="sm"
        // icon
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className={"now-ui-icons " + stateIcon} /> {stateText}
        </div>
      </Button>
    );
    return contractState;
  }
  getContractTemplates() {
    let contentToDisplay = null;
    let contractsToDisplay = null;
    // console.log("#################### TEMPLATES LIST #####################");
    // console.log(this.props.mainState.contractTemplates);
    if(this.props.mainState.contractTemplatesLoaded && this.props.mainState.contractTemplates.length > 0){
      contractsToDisplay = this.props.mainState.contractTemplates.slice(0);
      contentToDisplay = 
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Plantillas</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr className="text-primary">
                  {theadcontracttemplates.map((prop, key) => {
                    if (key === theadcontracttemplates.length - 1)
                      return (
                        <th key={key} className="text-center">
                          {prop}
                        </th>
                      );
                    return <th key={key} className="text-center">{prop}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {contractsToDisplay.map((template, key) => {
                  return (
                    <tr key={template.id}>
                      <td className="text-center">{template.titulo}</td>
                      <td className="text-center">{this.buildTemplateActions(template)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </CardBody>
        </Card>;
    } else if(this.props.mainState.contractTemplatesLoaded && this.props.mainState.contractTemplates.length == 0 /*&& this.props.mainState.isSearchBillResult*/) {
      contentToDisplay = (
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Contratos</CardTitle>
          </CardHeader>
          <CardBody>
            <Row>
              {/*<Label sm={2}>Buscar</Label>*/}
              <Col xs={12} sm={10}>
                No hay plantillas...
              </Col>
            </Row>
          </CardBody>
        </Card>
      );
    } else {
      contentToDisplay = 
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Plantillas</CardTitle>
          </CardHeader>
          <CardBody>
            <span><i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />  Cargando plantillas...</span>
          </CardBody>
        </Card>;
    }
    return contentToDisplay;
  }
  getContractStatusColor(status) {
    let color = "default";

    status = parseInt(status);
    switch (status) {
      case 229:
        color = "danger";
        break;
      case 238:
        color = "warning";
        break;
      case 230:
        color = "info";
        break;
      default:
        break;
    }

    return color;
  }
  buildContractsCount() {
    let contractsCount = null;
    if (this.props.mainState.contractsCount && this.props.mainState.contractsCount.length > 0) {
      contractsCount = 
        <Row>
          {this.props.mainState.contractsCount.map(currentStatus => {
            return (
              <Col 
                xs={12} 
                md={12}
                key={currentStatus.status_id} >
                <Card 
                  color={this.getContractStatusColor(currentStatus.status_id)}
                  onClick={() => this.searchFromCounter(currentStatus.status_name)}>
                  <CardHeader className="text-center">
                    <CardTitle tag="h4" style={{marginTop: "0px"}}>
                      <span 
                        style={{
                          borderRadius: "4px", 
                          background: "rgba(0,0,0,0.2)",
                          position: "absolute",
                          left: "0",
                          top: "0",
                          height: "100%",
                          width: "4em",
                          lineHeight: "2.5em",
                          fontWeight: "bold",
                          whiteSpace: "nowrap"
                      }}
                      >{currentStatus.count}</span> {currentStatus.status_name}
                    </CardTitle>
                  </CardHeader>
                </Card>
              </Col>
            );
          })}
        </Row>;
    } else {
      contractsCount = 
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Estado contratos</CardTitle>
          </CardHeader>
          <CardBody>
            No hay contratos pendientes
          </CardBody>
        </Card>;
    }
    return contractsCount;
  }
  searchFromCounter(status) {
    let newSearchQuery = "";
    let currentQuery = this.state.searchQuery;
    currentQuery = this.cleanStatusesFromSearchQuery(status, currentQuery);

    if (currentQuery && currentQuery.length > 0) {
      if (!currentQuery.includes(status)) {
        newSearchQuery = status + " + " + currentQuery;
      } else {
        newSearchQuery = currentQuery;
      }
    } else {
      newSearchQuery = status;
    }
    this.setState({ searchQuery: newSearchQuery });
    this.props.searchContracts(newSearchQuery);
  }
  cleanStatusesFromSearchQuery(status, query) {
    this.props.mainState.contractsCount.map( currentStatus => {
      query = query.replace(currentStatus.status_name, status);
      let expression = new RegExp(currentStatus.status_name, "gi");
      query = query.replace(expression, "");
    });
    return query;
  }
  parseDate(date) {
    let result = "";
    if (date) {
      result = date.replace("<span class=\"date-display-single\">", "").replace("</span>", "");
      // result = result.split("-")[1].replace(" ", "");
    }

    return result;
  }
  parseVisitType(type, name) {
    let result = null;
    let resultText = "";
    let resultStyle = "";
    type = parseInt(type);
    switch (type) {
      case 243:
        resultText = "Instalación WiFi";
        resultStyle = "btn-primary";
        break;
      case 244:
        resultText = "Incidencia";
        resultStyle = "btn-danger";
        break;
      case 245:
        resultText = "Configuración";
        resultStyle = "btn-info";
        break;
      case 246:
        resultText = "Servicio extra";
        resultStyle = "btn-info";
        break;
      case 256:
        resultText = "Instalación fibra";
        resultStyle = "btn-warning";
        break;
      default:
        resultText = "Error en el tipo";
        resultStyle = "btn-default";
        break;
    }
    resultStyle += " btn-sm btn-round btn";

    result = <span className={resultStyle}>{name}</span>;

    return result;
  }
  buildCurrentHomeVisit() {
    let result = null;
    if (this.props.mainState.homeVisits && this.props.mainState.homeVisits.current && Object.keys(this.props.mainState.homeVisits.current).length > 0) {   
      let homeVisit = this.props.mainState.homeVisits.current;
      result = (
        <Row>
          <Col xs={12}>
            <h4>Visita en marcha</h4>
            <Row>
              <Col xs={12}>
                <Link to={"/citas/" + homeVisit.id} style={{ color: "inherit" }}>
                  <Card className="card-stats" key={homeVisit.id} color="primary">
                    <CardHeader>
                      <CardTitle tag="h4">{homeVisit.title}</CardTitle>
                    </CardHeader>
                    <CardBody>
                      <Statistics
                        // horizontal
                        icon="business_money-coins"
                        iconState="primary"
                        title={homeVisit.visit_date_hour}
                        subtitle={this.parseVisitType(homeVisit.visit_type.tid, homeVisit.visit_type_name)}
                      />
                    </CardBody>
                    <hr />
                    <CardFooter>
                      <Stats>
                        {[{ i: "now-ui-icons location_pin", t: <span key="span-out"><span key="span-in" style={localityStyle}>{homeVisit.visit_locality}</span>{homeVisit.visit_address}</span>}]}
                      </Stats>
                    </CardFooter>
                  </Card>
                </Link>
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }
    return result;
  }
  getHomeVisitColor(status) {
    switch (status) {
      // Cancelada
      case 250:
        return "danger";
        break;
      // Esperando
      case 247:
        return "";
        break;
      // En proceso
      case 248:
        return "warning";
        break;
      // Finalizada
      case 249:
        return "default";
        break;
      default:
        return "";
        break;
    }
  }
  getClassifiedHomeVisitColorAndIcon(status, count) {
    let color = "default";
    let icon = "now-ui-icons ui-1_simple-add";
    switch (status) {
      // Cancelada
      case 250:
        color = "danger";
        icon = "ui-1_simple-remove";
        break;
      // Esperando
      case 247:
        color = "info";
        icon = "ui-2_time-alarm";
        break;
      // En proceso
      case 248:
        color = "warning";
        icon = "arrows-1_refresh-69 spin";
        break;
      // Finalizada
      case 249:
        color = "primary";
        icon = "ui-1_check";
        break;
      default:
        break;
    }

    return (
      <span key={status} className={"home-visit-status color-" + color}>
        <i className={"now-ui-icons ui-1 " + icon} /> {count}
      </span>
    );
  }
  classifyHomeVisits(homeVisits) {
    if (!homeVisits) return null;
    if (!Array.isArray(homeVisits)) return null;
    let result = [];
    homeVisits.map(homeVisit => {
      let status = parseInt(homeVisit.visit_status.tid);
      let aux = result[status];
      if (!aux) aux = 0;
      aux++;
      result[status] = aux;
    });
    let statuses = result.map((count, status) => {
      return this.getClassifiedHomeVisitColorAndIcon(status, count);
    });
    return <span className="home-visit-statuses">{statuses}</span>;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  render() {
    if (this.state.toDashboard === true) {
      this.redirectTo("/dashboard");
      // return <Redirect to="/dashboard" />;
    }
    if (this.state.goToCreateCustomer === true) {
      this.redirectTo("/clientes/crear");
      // return <Redirect to="/clientes/crear" />;
    }
    //console.log()
    // if (this.props.mainState.contractsLoaded && this.props.mainState.contracts.length > 0) this.loadOrdersChart();
    let contentToDisplay = null;
    let homeVisitsToDisplay = null;
    let currentHomeVisit = this.buildCurrentHomeVisit();
    // console.log("#################### BILLS LIST #####################");
    // console.log(this.props.mainState);
    if(this.props.mainState.homeVisitsLoaded && this.props.mainState.homeVisits.list && this.props.mainState.homeVisits.list.length > 0){
      homeVisitsToDisplay = this.props.mainState.homeVisits.grouped;
      contentToDisplay = (
        <Row>
          {Object.keys(homeVisitsToDisplay).map(currentMonth => {
            let homeVisits = homeVisitsToDisplay[currentMonth];
            let classifiedHomeVisits = this.classifyHomeVisits(homeVisits);
            let showHideHomeVisits = (
              <Button
                onClick={() => {
                  let showHomeVisits = this.state.showHomeVisits;
                  if (!showHomeVisits[currentMonth.toLowerCase()]) {
                    showHomeVisits[currentMonth.toLowerCase()] = true;
                  } else {
                    showHomeVisits[currentMonth.toLowerCase()] = false;
                  }
                  this.setState({ showHomeVisits: showHomeVisits });
                }}
                color="default"
                size="sm"
                className="show-home-visits"
              >
                {this.state.showHomeVisits[currentMonth.toLowerCase()] ? "Ocultar" : "Mostrar"}
              </Button>
            );
            let finishedCount = 0;
            return (
              <Col key={currentMonth} xs={12}>
                <h4 className="home-visits-day">{capitalizeFirst(currentMonth)}{classifiedHomeVisits}{showHideHomeVisits}</h4>
                {this.state.showHomeVisits[currentMonth.toLowerCase()] && 
                <Row>
                  {homeVisits.map(homeVisit => {

                    // <Si hay que ocultar las finalizadas y está finalizada, return null>
                    if (parseInt(homeVisit.visit_status.tid) === 249) {
                        finishedCount++;
                      }
                    if (!this.state.showFinishedHomeVisits[currentMonth] &&
                      parseInt(homeVisit.visit_status.tid) === 249) {
                        return null;
                      }
                    // </Si hay que ocultar las finalizadas y está finalizada, return null>

                    let working_technician = homeVisit.working_technician.map(technician => {
                      let badgeStyle = 
                      {
                        color: "default",
                        icon: "travel_info"
                      };
                      // if (comment.tipo === "Incidencia") {
                      //   badgeStyle.color = "danger";
                      //   badgeStyle.icon = "ui-2_settings-90";
                      // }
                      // if (comment.tipo === "Solución") {
                      //   badgeStyle.color = "primary";
                      //   badgeStyle.icon = "ui-2_like";
                      // }
                      // if (comment.tipo === "Log") {
                      //   badgeStyle.color = "warning";
                      //   badgeStyle.icon = "ui-1_bell-53";
                      // }
                      // if (comment.tipo === "Pago") {
                      //   badgeStyle.color = "primary";
                      //   badgeStyle.icon = "business_money-coins";
                      // }
            
                      return {
                        inverted: true,
                        badgeColor: "primary",
                        badgeUserPicture: technician.picture || "no-tiene",
                        // badgeIcon: null,
                        title: technician.username,
                        // titleColor: comment.pending ? "warning" : "primary",
                        titleColor: "primary",
                        // body: <div dangerouslySetInnerHTML={{ __html: technician.name }} />,
                        // footerTitle: technician.mail,
                        footerIcon: "now-ui-icons ui-1_email-85"
                      };
                    });
                    let assigned_technician = homeVisit.assigned_technician.map(technician => {
                      let badgeStyle = 
                      {
                        color: "default",
                        icon: "travel_info"
                      };
                      // if (comment.tipo === "Incidencia") {
                      //   badgeStyle.color = "danger";
                      //   badgeStyle.icon = "ui-2_settings-90";
                      // }
                      // if (comment.tipo === "Solución") {
                      //   badgeStyle.color = "primary";
                      //   badgeStyle.icon = "ui-2_like";
                      // }
                      // if (comment.tipo === "Log") {
                      //   badgeStyle.color = "warning";
                      //   badgeStyle.icon = "ui-1_bell-53";
                      // }
                      // if (comment.tipo === "Pago") {
                      //   badgeStyle.color = "primary";
                      //   badgeStyle.icon = "business_money-coins";
                      // }
            
                      return {
                        inverted: true,
                        badgeColor: badgeStyle.color,
                        badgeUserPicture: technician.picture || "no-tiene",
                        // badgeIcon: null,
                        title: technician.username,
                        // titleColor: comment.pending ? "warning" : "primary",
                        titleColor: "default",
                        // body: <div dangerouslySetInnerHTML={{ __html: technician.name }} />,
                        // footerTitle: technician.mail,
                        footerIcon: "now-ui-icons ui-1_email-85"
                      };
                    });
                    let viewed_by = homeVisit.viewed_by.map(technician => {
                      let badgeStyle = 
                      {
                        color: "info",
                        icon: "travel_info"
                      };
                      // if (comment.tipo === "Incidencia") {
                      //   badgeStyle.color = "danger";
                      //   badgeStyle.icon = "ui-2_settings-90";
                      // }
                      // if (comment.tipo === "Solución") {
                      //   badgeStyle.color = "primary";
                      //   badgeStyle.icon = "ui-2_like";
                      // }
                      // if (comment.tipo === "Log") {
                      //   badgeStyle.color = "warning";
                      //   badgeStyle.icon = "ui-1_bell-53";
                      // }
                      // if (comment.tipo === "Pago") {
                      //   badgeStyle.color = "primary";
                      //   badgeStyle.icon = "business_money-coins";
                      // }
            
                      return {
                        inverted: true,
                        badgeColor: badgeStyle.color,
                        badgeUserPicture: technician.picture || "no-tiene",
                        // badgeIcon: null,
                        title: technician.username,
                        // titleColor: comment.pending ? "warning" : "primary",
                        titleColor: "info",
                        // body: <div dangerouslySetInnerHTML={{ __html: technician.name }} />,
                        // footerTitle: technician.mail,
                        footerIcon: "now-ui-icons ui-1_email-85"
                      };
                    });
                    // console.log("###### ASSIGNED TECHNICIANS CLEAN ######");
                    // console.log(assigned_technician);
                    return (
                      <Col xs={12} lg={6} key={homeVisit.id}>
                        <Link to={"/citas/" + homeVisit.id} style={{ color: "inherit" }}>
                          <Card className="card-stats" color={this.getHomeVisitColor(parseInt(homeVisit.visit_status.tid))}>
                            <CardHeader>
                              <CardTitle tag="h4">{homeVisit.title}</CardTitle>
                            </CardHeader>
                            <CardBody>
                              <Row>
                                <Col xs={12} md={4}>
                                  <Statistics
                                    // horizontal
                                    icon="business_money-coins"
                                    iconState="primary"
                                    title={homeVisit.visit_date_hour}
                                    subtitle={this.parseVisitType(homeVisit.visit_type.tid, homeVisit.visit_type_name)}
                                  />
                                </Col>
                                {!this.props.userData.isTechnician() && <Col xs={12} md={4}>
                                  <Card key="techniciansCard" className="card-plain card-timeline">
                                    <h7>Técnicos asignados</h7>
                                    <CardBody>
                                      <Technician stories={assigned_technician} simple />
                                      {(!homeVisit.assigned_technician || (homeVisit.assigned_technician && homeVisit.assigned_technician.length === 0)) ? "Ninguno" : ""}
                                    </CardBody>
                                  </Card>
                                </Col>}
                                {!this.props.userData.isTechnician() && <Col xs={12} md={4}>
                                  <Card key="techniciansWorkingCard" className="card-plain card-timeline">
                                    <h7>Técnicos trabajando</h7>
                                    <CardBody>
                                      <Technician stories={working_technician} simple />
                                      {(!homeVisit.working_technician || (homeVisit.working_technician && homeVisit.working_technician.length === 0)) ? "Ninguno" : ""}
                                    </CardBody>
                                  </Card>
                                </Col>}
                                {!this.props.userData.isTechnician() && <Col xs={12}>
                                  <Card key="viewedByCard" className="card-plain card-timeline">
                                    <span className="text-black">Visto por</span>
                                    <CardBody>
                                      <Technician stories={viewed_by} simple />
                                      {(!homeVisit.viewed_by || (homeVisit.viewed_by && homeVisit.viewed_by.length === 0)) ? "Nadie" : ""}
                                    </CardBody>
                                  </Card>
                                </Col>}
                              </Row>
                            </CardBody>
                            <hr />
                            <CardFooter>
                              <Stats>
                                {[{ i: "now-ui-icons location_pin", t: <span key="span-out"><span key="span-in" style={localityStyle}>{homeVisit.visit_locality}</span>{homeVisit.visit_address}</span>}]}
                              </Stats>
                            </CardFooter>
                          </Card>
                        </Link>
                      </Col>
                    );
                  })}
                  {finishedCount > 0 &&
                      <Col xs={12} lg={6}>
                        <Card 
                          className="card-stats building-card" 
                          color="primary"
                          onClick={() => {
                            let showFinishedHomeVisits = this.state.showFinishedHomeVisits;
                            if (!showFinishedHomeVisits[currentMonth]) {showFinishedHomeVisits[currentMonth] = true;}
                            else {showFinishedHomeVisits[currentMonth] = false;}
                            this.setState({ showFinishedHomeVisits: showFinishedHomeVisits });
                          }}
                          >
                          <CardHeader>
                            {/* <CardTitle tag="h4">{homeVisit.title}</CardTitle> */}
                          </CardHeader>
                          <CardBody className="text-center txt-white h3 h-nomargin">
                            <Row>
                              <Col xs={12}>
                                {finishedCount + (finishedCount > 1 ? " finalizadas" : " finalizada")}
                              </Col>
                            </Row>
                          </CardBody>
                          <hr />
                          <CardFooter className="text-center">
                            {this.state.showFinishedHomeVisits[currentMonth] ? "Ocultar finalizadas" : "Mostrar finalizadas"}
                           
                            {/* <Stats>
                              {[{ i: "now-ui-icons location_pin", t: <span key="span-out"><span key="span-in" style={localityStyle}>{homeVisit.visit_locality}</span>{homeVisit.visit_address}</span>}]}
                            </Stats> */}
                          </CardFooter>
                        </Card>
                      </Col>}
                </Row>}
              </Col>
            );
          })}
        </Row>
      );
    } else if(!this.props.mainState.isSearchHomeVisitsResult && this.props.mainState.homeVisitsLoaded && this.props.mainState.homeVisits.list.length == 0 /*&& this.props.mainState.isSearchBillResult*/) {
      contentToDisplay = (
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Citas</CardTitle>
          </CardHeader>
          <CardBody>
            <Row>
              {/*<Label sm={2}>Buscar</Label>*/}
              <Col xs={12} sm={10}>
                No hay citas ...
              </Col>
            </Row>
          </CardBody>
        </Card>
      );
    } else if (
      this.props.mainState.isSearchHomeVisitsResult &&
      this.props.mainState.homeVisitsLoaded &&
      this.props.mainState.homeVisits.list &&
      this.props.mainState.homeVisits.list.length === 0
    ) {
      contentToDisplay = (
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Citas</CardTitle>
          </CardHeader>
          <CardBody>
            <Row>
              {/*<Label sm={2}>Buscar</Label>*/}
              <Col xs={12} sm={10}>
                No hay resultados para{" "}
                <b>{this.props.mainState.searchHomeVisitsQuery}</b>...
              </Col>
            </Row>
          </CardBody>
        </Card>
      );
    } else {
      contentToDisplay = 
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Visitas</CardTitle>
          </CardHeader>
          <CardBody>
            <span>No hay visitas para mostrar que coincidan con la búsqueda</span>
          </CardBody>
        </Card>;
    }

    let createHomeVisitButton = (
      <Link to={"/citas/nueva"}>
        <Button round color="info">
          <i className="now-ui-icons ui-1_simple-add" /> Nueva cita
        </Button>
      </Link>
    );

    return (
      <div>
      <PanelHeader
        size="sm"
      />
        <div className="content">
          {this.state.showPopUp && this.createPopUp()}
          {this.state.popUpConfirmation}
          <Row>
            <Col lg={3} md={6} xs={12}>
              <Card>
                <CardBody className="form-inline">
                  <Input type="text" 
                    placeholder="Buscar cita..."
                    value={this.state.searchQuery}
                    onChange={(e) => this.handleChange("searchQuery", e)}
                    onKeyDown={e => {
                      //console.log(e.keyCode);
                      if(e.keyCode == 13){
                        //Enter is key code 13
                        this.searchHomeVisits();
                        // put the login here
                      }
                    }}
                    style={{marginRight:"10px"}}
                  />
                  <Button
                    color={
                      this.props.mainState.isSearchingBills
                        ? "default"
                        : "primary"
                    }
                    round 
                    icon 
                    onClick={this.searchHomeVisits}>
                    <i className={this.props.mainState.isSearchingHomeVisits?
                                          "now-ui-icons arrows-1_refresh-69 spin reposition-spin" :"now-ui-icons ui-1_zoom-bold"} />
                  </Button>
                  <Button className="txt-black" round color="default" onClick={() => this.setState({ showFilter: !this.state.showFilter })}>
                    {this.state.showFilter ? "Ocultar filtro" : "Filtrar por fechas"}
                  </Button>
                </CardBody>
              </Card>
            </Col>
            {/*<Label sm={2}>Buscar</Label>*/}
            {!this.props.userData.isTechnician() && <Col lg={3} md={6} xs={12}>
              {createHomeVisitButton}
            </Col>} 
          </Row>
          {this.state.showFilter && <Row>
            <Col xs={12} md={4}>
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Desde</CardTitle>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Datetime
                      timeFormat={false}
                      inputProps={{ placeholder: "Selecciona el día" }}
                      value={this.state.date_day_min}
                      onChange={value => this.setState({ date_day_min: value })}
                    />
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Hasta</CardTitle>
                </CardHeader>
                <CardBody>
                  <FormGroup>
                    <Datetime
                      timeFormat={false}
                      inputProps={{ placeholder: "Selecciona el día" }}
                      value={this.state.date_day_max}
                      onChange={value => this.setState({ date_day_max: value })}
                    />
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>}
          <Row>
            {/* {this.state.showDetail && orderArticles} */}
            <Col xs={12}>
              {currentHomeVisit}
              {contentToDisplay}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

function capitalizeFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default HomeVisitsList;



// WEBPACK FOOTER //
// ./src/views/Assistances/HomeVisitsList.jsx